<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div class="light-shade box rounded-corners" style="width: 100%; max-width: 600px">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>Search for Summons</div>
        </div>
        <div style="padding: 10px">
          <div style="padding: 10px">
            <table class="search-form-table">
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">Summons&nbsp;Number:</span>
                </td>
                <td style="display: flex; align-items: center; flex-wrap: wrap">
                  <dx-text-box
                    #summons_number_el
                    [(value)]="summons_number"
                    valueChangeEvent="keyup change"
                    [disabled]="set2 || set3"
                    [showClearButton]="true"
                    (onEnterKey)="searchEnterKeyPressed($event)"
                    [tabindex]="1"
                    [maxLength]="20">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                  <div style="margin-left: 5px">
                    <a target="sampletickets" routerLink="/sampletickets/nassau" [tabindex]="-1">
                      <img src="{{ env.assetsPath }}images/Information_24x24.png" />
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="text-align: right"></td>
                <td style="text-align: center">
                  <span class="LabelHeader SearchOR" style="padding-right: 40px">- OR -</span>
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">License Plate:</span>
                </td>
                <td>
                  <dx-text-box
                    [(value)]="plate_number"
                    valueChangeEvent="keyup change"
                    [showClearButton]="true"
                    [disabled]="set1 || set3"
                    [tabindex]="5"
                    [maxLength]="15">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">State:</span>
                </td>
                <td>
                  <dx-select-box
                    width="100%"
                    [searchEnabled]="true"
                    [dataSource]="stateList"
                    [(value)]="plate_state"
                    displayExpr="state_display"
                    valueExpr="state_code"
                    [disabled]="set1 || set3"
                    [showClearButton]="true"
                    valueChangeEvent="keyup change"
                    [tabindex]="10"
                    (onEnterKey)="searchEnterKeyPressed($event)"
                    placeholder="Select State"
                    searchMode="startswith">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </td>
              </tr>
              <tr>
                <td style="text-align: right"></td>
                <td style="text-align: center">
                  <span class="LabelHeader SearchOR" style="padding-right: 40px">- OR -</span>
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">Driver’s License Number:</span>
                </td>
                <td>
                  <dx-text-box
                    [(value)]="license_number"
                    valueChangeEvent="keyup change"
                    [disabled]="set1 || set2"
                    [showClearButton]="true"
                    [tabindex]="15"
                    [maxLength]="20">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </td>
              </tr>
              <tr id="motoristInfo3">
                <td style="text-align: right">
                  <span class="LabelHeader">State:</span>
                </td>
                <td>
                  <dx-select-box
                    width="100%"
                    [searchEnabled]="true"
                    [dataSource]="stateList"
                    [(value)]="license_state"
                    displayExpr="state_display"
                    valueExpr="state_code"
                    [disabled]="set1 || set2"
                    [showClearButton]="true"
                    valueChangeEvent="keyup change"
                    [tabindex]="20"
                    placeholder="Select State">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">Last Name:</span>
                </td>
                <td>
                  <dx-text-box
                    [(value)]="last_name"
                    valueChangeEvent="keyup change"
                    [disabled]="set1 || set2"
                    [showClearButton]="true"
                    [tabindex]="25">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  <span class="LabelHeader">Date of Birth:</span>
                </td>
                <td>
                  <dx-date-box
                    [(value)]="dob"
                    valueChangeEvent="keyup change"
                    [disabled]="set1 || set2"
                    [showClearButton]="true"
                    [tabindex]="30"
                    (onEnterKey)="searchEnterKeyPressed($event)"
                    [useMaskBehavior]="true"
                    placeholder="MM/DD/YYYY">
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                  </dx-date-box>
                </td>
              </tr>
              @if (!isDevelopmentMode) {
                <tr>
                  <td></td>
                  <td>
                    <re-captcha
                      (resolved)="resolved($event)"
                    siteKey="6Le64C0dAAAAAEMABRBusksYjtj1D7bsOn2cQN5p"></re-captcha>
                  </td>
                </tr>
              }
            </table>
          </div>

          <div class="search-actions" style="height: auto; display: flex; margin-left: 10px; flex-wrap: wrap">
            <div style="padding-top: 5px; float: left; height: 40px">
              <dx-button
                text="Search"
                icon="{{ env.assetsPath }}images/Search_16x16.png"
                width="150px"
                (onClick)="searchClick()"
              [tabindex]="35"></dx-button>
            </div>
            <div style="padding-top: 5px; padding-left: 5px">
              <dx-button
                text="Reset"
                icon="{{ env.assetsPath }}images/Refresh_16x16.png"
                width="150px"
                (onClick)="reset()"
              [tabindex]="40"></dx-button>
            </div>
            <div class="errorMessage" style="padding-right: 10px; padding-left: 10px">
              @if (invalidEntries) {
                <div>
                  Either Summons Number or License Plate and State or Motorist ID, State, Last Name and DOB are required
                </div>
              }
              @if (noTicketFound) {
                <div class="TicketNotFound" style="width: 200px">
                  <div style="float: left; margin-left: 15px; margin-right: 15px">
                    <img src="{{ env.assetsPath }}images/Warning-24x24.png" />
                  </div>
                  <div style="margin-left: 5px; margin-top: 3px">No Tickets Found</div>
                </div>
              }
              @if (technicalProblem) {
                <div class="TicketNotFound" style="width: 100%">
                  <div style="float: left; margin-left: 15px; margin-right: 15px">
                    <img src="{{ env.assetsPath }}images/Warning-24x24.png" />
                  </div>
                  <div style="margin-left: 5px">
                    There was a technical problem with the search. Please try again later.
                  </div>
                </div>
              }
              @if (duplicateParking) {
                <div class="TicketNotFound" style="width: 100%">
                  <div style="float: left; margin-left: 15px; margin-right: 15px">
                    <img src="{{ env.assetsPath }}images/Warning-24x24.png" />
                  </div>
                  <div style="margin-left: 5px">
                    Multiple tickets match your summons search. You must use the Plate search option instead.
                  </div>
                </div>
              }
              @if (duplicateTraffic) {
                <div class="TicketNotFound" style="width: 100%">
                  <div style="float: left; margin-left: 15px; margin-right: 15px">
                    <img src="{{ env.assetsPath }}images/Warning-24x24.png" />
                  </div>
                  <div style="margin-left: 5px">
                    Multiple tickets match your summons search.<br />
                    You must use the Driver's License search option instead.
                  </div>
                </div>
              }
            </div>
          </div>

          <div style="display: flex; margin-top: 10px; margin-left: 10px; margin-bottom: 10px; flex-wrap: wrap">
            <div style="margin-right: 5px">
              <img src="{{ env.assetsPath }}images/Mastercard2.png" />
            </div>
            <div style="margin-right: 5px">
              <img src="{{ env.assetsPath }}images/Visa2.png" />
            </div>
            <div style="margin-right: 5px">
              <img src="{{ env.assetsPath }}images/Discover2.png" />
            </div>
            <div>
              <img src="{{ env.assetsPath }}images/Amex2.png" />
            </div>
          </div>
        </div>
      </div>
      <div
        style="margin-top: 10px"
        class="dark-shade search-message box rounded-corners"
      [innerHtml]="siteInfo?.search_message"></div>
      <div
        style="margin-top: 10px"
        class="dark-shade search-message box rounded-corners"
      [innerHtml]="siteInfo?.search_message2"></div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
